// extracted by mini-css-extract-plugin
export default {"label":"_14X9GrFnBuTaC30i3vbfTp","badge":"-qJ6bIBLF17hxOyF54nq6","badgeSelected":"_36g-oQmjcQg0rTIN3laaug"};